var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "member_label_tabs" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card" },
          on: { "tab-remove": _vm.handleTabRemove },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "会员标签列表", name: "member_label_table" } },
            [
              _c("member-label-table-pane", {
                on: { openMemberListTab: _vm.handleOpenMemberListTab },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.memberListTabs, function (item) {
            return _c(
              "el-tab-pane",
              {
                key: item.name,
                attrs: { label: item.title, name: item.name, closable: "" },
              },
              [
                _c("member-list-by-label", {
                  attrs: { "label-data": item.labelData },
                }),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }